// Utility functions for dynamic portfolio statistics
import { certifications, awards } from '../data/mockData';

/**
 * Calculate total years of experience from all positions
 * Based on manual calculation: 14 years, 0 months, 1 day (5,114 days total)
 * @returns {string} Experience in format "14+" years
 */
const calculateTotalExperience = () => {
  // Based on your detailed manual calculation, the total is 14 years
  // Let's use the precise calculation you provided
  const totalDays = 5114; // From your manual calculation
  const totalYears = totalDays / 365.25;
  
  // Since your calculation shows 14 years, 0 months, 1 day
  // Math.floor should give us 14
  const roundedYears = Math.floor(totalYears);
  return `${roundedYears}+`;
};

/**
 * Get total number of certifications
 * @returns {number} Total certifications count
 */
export const getTotalCertifications = () => {
  return certifications.length;
};

/**
 * Get total number of awards with "+" suffix
 * @returns {string} Awards count in format "5+"
 */
export const getTotalAwards = () => {
  return `${awards.length}+`;
};

/**
 * Get experience for display in various formats
 * @returns {object} Different formats of experience
 */
export const getExperienceFormats = () => {
  const baseExp = calculateTotalExperience();
  return {
    withYears: `${baseExp} years`,
    withOver: `over ${baseExp} years`,
    mastery: `${baseExp} Years Mastery`,
    code: `"${baseExp} years"`,
    statsDisplay: baseExp  // Just the "13+" without years for stats
  };
};